(function () {
  'use strict';

  const { iman, Search, GalleryCard, ModalProduct, CollectionGridFilters } = window.Universe;

  class SearchTemplate {
    constructor() {
      this.onFocus = () => {
        this.expand();
      };

      this.onCloseSearch = () => {
        this.collapse();
      };

      this.onKeyDownSearch = (e) => {
        if (e.key === 'Escape') {
          this.collapse();
          this.DOM.searchInput.blur();
        }
      };

      this.onTrapFocusKeydown = (e) => {
        if (e.key !== 'Tab' || !this.trapElement) return;

        const focusableElements = this.trapElement.querySelectorAll(
          'button:not([disabled]):not([tabindex="-1"]), [href]:not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])',
        );
        const first = focusableElements[0];
        const last = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === first) {
            last.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === last) {
            first.focus();
            e.preventDefault();
          }
        }
      };

      this.init();
    }

    expand() {
      if (this.DOM.gsearchContent) {
        this.DOM.gsearchContent.classList.remove('is-collapsed');
        this.DOM.gsearchContent.classList.add('solid');
      }
      this.DOM.searchCloser.style.opacity = '1';
      this.DOM.searchCloser.style.pointerEvents = 'all';
      this.DOM.searchCloser.style.zIndex = '41';
      this.trapFocus(this.DOM.searchLayer);
    }

    collapse() {
      if (this.DOM.gsearchContent) {
        this.DOM.gsearchContent.classList.add('is-collapsed');
        this.DOM.gsearchContent.classList.remove('solid');
      }
      this.DOM.searchCloser.style.opacity = '';
      this.DOM.searchCloser.style.pointerEvents = '';
      this.DOM.searchCloser.style.zIndex = '';
      this.removeTrapFocus();
    }

    setup() {
      this.setSearch();
      this.filters = new CollectionGridFilters(this.DOM.filters, this.DOM.section, this.update.bind(this));
      this.setupCards();
    }

    update() {
      this.destroyCards();
      this.setupCards();
    }

    reinit() {
      this.destroy();
      this.init();
    }

    setSearch() {
      if (this.DOM.searchLayer) {
        this.DOM.searchContent = this.DOM.searchLayer.querySelector('.js-gsearch-content');
        this.DOM.searchInput = this.DOM.searchLayer.querySelector('.js-gsearch-input');
        this.DOM.gsearchContent = this.DOM.searchLayer.querySelector('.gsearch__content');
        this.DOM.gsearchMain = this.DOM.searchLayer.querySelector('.gsearch__main');

        this.searchInstance = new Search(this.DOM.searchLayer);
        this.DOM.searchCloser.addEventListener('click', this.onCloseSearch);
        this.DOM.searchInput.addEventListener('focus', this.onFocus);
        document.addEventListener('keydown', this.onKeyDownSearch);
      }
    }

    trapFocus(element) {
      this.removeTrapFocus();
      this.trapElement = element;
      document.addEventListener('keydown', this.onTrapFocusKeydown);
    }

    removeTrapFocus() {
      document.removeEventListener('keydown', this.onTrapFocusKeydown);
      this.trapElement = null;
    }

    setupCards() {
      this.DOM.cards = this.DOM.section.querySelectorAll('.js-gallery-card');
      this.DOM.quickAdd = document.querySelector('.js-quick-add-container');

      if (this.DOM.cards) {
        this.cards = [];
        this.quickAdds = [];

        this.DOM.cards.forEach((card) => {
          const cardInstance = new GalleryCard(card);
          this.cards.push(cardInstance);

          if (this.DOM.quickAdd) {
            const cardQuickAdd = new ModalProduct(card, this.DOM.quickAdd);
            this.quickAdds.push(cardQuickAdd);
          }
        });
      }
    }

    destroyCards() {
      if (this.cards) {
        this.cards.forEach((card) => {
          card.destroy();
        });
      }
      if (this.quickAdds) {
        this.quickAdds.forEach((quickAdd) => {
          quickAdd.destroy();
        });
      }

      this.cards = undefined;
      this.quickAdds = undefined;
      this.DOM.cards = undefined;
      this.DOM.quickAdds = undefined;
    }

    destroy() {
      if (this.DOM) {
        if (this.DOM.searchLayer && this.searchInstance) {
          this.DOM.searchCloser.removeEventListener('click', this.onCloseSearch);
          this.DOM.searchInput.removeEventListener('focus', this.onFocus);
          document.removeEventListener('keydown', this.onKeyDownSearch);
          this.removeTrapFocus();
          this.searchInstance.destroy();
          this.searchInstance = undefined;
        }

        this.destroyCards();
        this.DOM = undefined;
      }
    }

    init(container) {
      if (!container) container = document;
      const searchTemplate = container.querySelector('.js-template-search');

      if (searchTemplate) {
        this.DOM = {};

        // Search
        this.DOM.searchActivators = container.querySelectorAll('.js-gsearch-toggle');
        this.DOM.searchCloser = container.querySelector('.js-gsearch-close');
        this.DOM.searchLayer = container.querySelector('.js-gsearch');
        if (this.DOM.searchLayer) {
          this.DOM.searchLayer.removeAttribute('aria-hidden');
        }
        this.DOM.section = container.querySelector('.js-main-search');
        this.DOM.filters = this.DOM.section.querySelector('.js-filters');

        this.searchInstance = undefined;
        this.cards = [];
        this.quickAdds = [];

        this.setup();
      }
    }
  }

  function init() {
    if (!iman.get('searchTemplate')) {
      iman.add('searchTemplate', new SearchTemplate());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.Universe.SearchTemplate = SearchTemplate;
})();
